const Actions = {
  LIST_USERS: "LIST_USERS",
  LIST_USERS_SUCCEEDED: "LIST_USERS_SUCCEEDED",
  CREATE_USER: "CREATE_USER",
  CREATE_USER_SUCCEEDED: "CREATE_USER_SUCCEEDED",
  RECEIVE_USER: "RECEIVE_USER",
  RESEND_EMAIL_CONFIRMATION: "RESEND_EMAIL_CONFIRMATION",
  RESEND_EMAIL_CONFIRMATION_SUCCEEDED: "RESEND_EMAIL_CONFIRMATION_SUCCEEDED",
  READ_USER: "READ_USER",
  READ_USER_SUCCEEDED: "READ_USER_SUCCEEDED",
  CLEAR_BULK_DELETE_OPERATION_RESULT: "CLEAR_BULK_DELETE_OPERATION_RESULT",
  DELETE_USER: "DELETE_USER",
  DELETE_USER_SUCCEEDED: "DELETE_USER_SUCCEEDED",
  UNLOCK_USER: "UNLOCK_USER",
  UNLOCK_USER_SUCCEEDED: "UNLOCK_USER_SUCCEEDED",
  BULK_DELETE_USERS: "BULK_DELETE_USERS",
  BULK_DELETE_USERS_SUCCEEDED: "BULK_DELETE_USERS_SUCCEEDED",
  UPDATE_USER: "UPDATE_USER",
  UPDATE_USER_SUCCEEDED: "UPDATE_USER_SUCCEEDED",
  CLEAR_SELECTED_USER: "CLEAR_SELECTED_USER",
  CLEAR_DELETE_OPERATION_RESULTS: "CLEAR_DELETE_OPERATION_RESULTS",
  CLEAR_IDENTITY_OPERATION_RESULT: "CLEAR_IDENTITY_OPERATION_RESULT",
  CLEAR_OPERATION_RESULT: "CLEAR_OPERATION_RESULT",
  LIST_LEGACY_USERS: "LIST_LEGACY_USERS",
  LIST_LEGACY_USERS_SUCCEEDED: "LIST_LEGACY_USERS_SUCCEEDED",
  CLEAR_LEGACY_OPERATION_RESULT: "CLEAR_LEGACY_OPERATION_RESULT",
  ACITVATE_LEGACY_USER: "ACITVATE_LEGACY_USER",
  ACITVATE_LEGACY_USER_SUCCEEDED: "ACITVATE_LEGACY_USER_SUCCEEDED",
  CHANGE_PASSWORD: "CHANGE_PASSWORD",
  CHANGE_PASSWORD_SUCCEEDED: "CHANGE_PASSWORD_SUCCEEDED",
  SET_SELECTED_USER_ROWS: "SET_SELECTED_USER_ROWS",
  CLEAR_SELECTED_USER_ROWS: "CLEAR_SELECTED_USER_ROWS",
  SET_SELECTED_LEGACY_USER_ROWS: "SET_SELECTED_LEGACY_USER_ROWS",
  CLEAR_SELECTED_LEGACY_USER_ROWS: "CLEAR_SELECTED_LEGACY_USER_ROWS",
  SETTINGS_LOAD_STATUS: "SETTINGS_LOAD_STATUS",
  SETTINGS_LOAD_STATUS_SUCCEEDED: "SETTINGS_LOAD_STATUS_SUCCEEDED",
  SETTINGS_SET_PREFERRED_MFA: "SETTINGS_SET_PREFERRED_MFA",
  SETTINGS_SET_PREFERRED_MFA_SUCCEEDED: "SETTINGS_SET_PREFERRED_MFA_SUCCEEDED",
  SETTINGS_SET_PHONE_NUMBER: "SETTINGS_SET_PHONE_NUMBER",
  SETTINGS_SET_PHONE_NUMBER_SUCCEEDED: "SETTINGS_SET_PHONE_NUMBER_SUCCEEDED",
  SETTINGS_VERIFY_AUTHENTICATOR: "SETTINGS_VERIFY_AUTHENTICATOR",
  SETTINGS_VERIFY_AUTHENTICATOR_SUCCEEDED:
    "SETTINGS_VERIFY_AUTHENTICATOR_SUCCEEDED",
  SETTINGS_RESET_AUTHENTICATOR: "SETTINGS_RESET_AUTHENTICATOR",
  SETTINGS_RESET_AUTHENTICATOR_SUCCEEDED:
    "SETTINGS_RESET_AUTHENTICATOR_SUCCEEDED",
  SETTINGS_CLEAR_RESULT: "SETTINGS_CLEAR_RESULT",
  SETTINGS_GET_AUTH_QR_START: "SETTINGS_GET_AUTH_QR_START",
  SETTINGS_GET_AUTH_QR_SUCCESS: "SETTINGS_GET_AUTH_QR_SUCCESS",
};
export default Actions;
